import { render, staticRenderFns } from "./mybookingItem.vue?vue&type=template&id=71b8ee1a&scoped=true"
import script from "./mybookingItem.vue?vue&type=script&lang=js"
export * from "./mybookingItem.vue?vue&type=script&lang=js"
import style0 from "./mybookingItem.vue?vue&type=style&index=0&id=71b8ee1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b8ee1a",
  null
  
)

export default component.exports